import "./App.scss";
import "./styles/global.scss";
import "./styles/CalendarStyles.css";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { auth } from "./firebase/firebaseConfig";
import { useState, useEffect } from "react";

import SideBar from "./components/SideBar/SideBar";
import TopNav from "./components/TopNav/TopNav";
import Moderators from "./pages/Moderators/Moderators";
import Users from "./pages/Users/Users";
import AddUsers from "./pages/AddUsers/AddUsers";
import EditUsers from "./pages/EditUsers/EditUsers";
import Venues from "./pages/Venues/Venues";
import AddVenue from "./pages/AddVenue/AddVenue";
import Events from "./pages/Events/Events";
import Queries from "./pages/Queries/Queries";
import Sponsorship from "./pages/Sponsorship/Sponsorship";
import EditVenue from "./pages/EditVenue/EditVenue";
import Settings from "./pages/Settings/Settings";
import PrivacySettings from "./components/PrivacySettings/PrivacySettings";
import NotificationSettings from "./components/NotificationSettings/NotificationSettings";
import TermsAndConditions from "./components/TermsAndConditions/TermsAndConditions";
import Promotion from "./pages/Promotion/Promotion";
import UserProfile from "./pages/UserProfile/UserProfile";
import AddEvent from "./pages/AddEvent/AddEvent";
import EditEvent from "./pages/EditEvent/EditEvent";
import SignIn from "./pages/SignIn/SignIn";
import AdManagement from "./pages/AdManagement/AdManagement";

function App() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUser(user);
            setLoading(false);
        });

        return () => {
            unsubscribe();
        };
    }, []);

    if (loading) {
        return null;
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/signin" element={<SignIn />} />

                <Route path='/signin' element={<SignIn />} />

                {
                    user
                        ?
                        <>

                            <Route path="/" element={<Moderators />} />
                            <Route path="/moderators" element={<Moderators />} />
                            <Route path="/users" element={<Users />} />
                            <Route path="/users/add" element={<AddUsers />} />
                            <Route path="/users/edit/:userID" element={<EditUsers />} />
                            <Route path="/users/:userID" element={<UserProfile />} />
                            <Route path="/venues" element={<Venues />} />
                            <Route path="/venues/add" element={<AddVenue />} />
                            <Route
                                path="/venues/edit/:venueId"
                                element={<EditVenue />}
                            />
                            <Route path="/events" element={<Events />} />
                            <Route path='/events/add' element={<AddEvent />} />
                            <Route path='/events/edit/:eventID' element={<EditEvent />} />
                            <Route path="/queries" element={<Queries />} />
                            <Route path="/sponsoring" element={<Sponsorship />} />
                            <Route path='/ad-management' element={<AdManagement />} />
                            <Route path="/promotion" element={<Promotion />} />
                            <Route path="/settings" element={<Settings />}>
                                <Route path="privacy" element={<PrivacySettings />} />
                                <Route
                                    path="notifications"
                                    element={<NotificationSettings />}
                                />
                                <Route
                                    path="terms-and-conditions"
                                    element={<TermsAndConditions />}
                                />
                            </Route>
                        </>

                        :

                        <Route path="*" element={<Navigate to="/signin" />} />
                }


            </Routes>
        </BrowserRouter>
    );
}

export default App;
